<template>
  <v-container class="favorites">
    <h1 class="favorites__title">{{ t("title") }}</h1>

    <v-row v-if="loading" class="mt-6">
      <v-col v-for="n in 3" :key="n" cols="12" sm="6" md="4">
        <v-skeleton-loader type="card-avatar, article"></v-skeleton-loader>
      </v-col>
    </v-row>

    <div v-else-if="!items.length" class="favorites__empty">
      <p>{{ t("empty") }}</p>
      <v-btn depressed color="primary" :href="catalogUrl">{{ t("toCatalog") }}</v-btn>
    </div>

    <v-row v-else class="mt-6">
      <v-col v-for="item in items" :key="item.id" cols="12" sm="6" md="4">
        <div class="favorite-card">
          <button
            class="favorite-card__remove"
            :title="t('remove')"
            :aria-label="t('remove')"
            :disabled="busy === item.id"
            @click="remove(item)"
          >
            <v-icon color="#00A3B7">mdi-heart</v-icon>
          </button>
          <a :href="item.public_url" class="favorite-card__link">
            <v-avatar size="140" class="favorite-card__photo">
              <img :src="item.photo" :alt="item.full_name" />
            </v-avatar>
            <div class="favorite-card__name">{{ item.name }} {{ item.surname }}</div>
            <div v-if="item.specialty" class="favorite-card__specialty">{{ item.specialty }}</div>
            <div v-if="item.main_treatment_methods.length" class="favorite-card__methods">
              {{ item.main_treatment_methods.join(", ") }}
            </div>
            <div v-for="(price, i) in prices(item)" :key="i" class="favorite-card__price">
              {{ price.title }} - <b>{{ formatPrice(price) }}</b>
            </div>
            <span class="favorite-card__more">{{ t("open") }}</span>
          </a>
          <router-link class="favorite-card__chat" :to="{ name: 'chat', query: { to: item.id } }">
            <v-icon small color="#00A3B7">mdi-message-text-outline</v-icon> Написати
          </router-link>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Vue from "vue";
import AppServices from "@/services/api/app.services";

const CURRENCY_SIGNS = { UAH: "₴", USD: "$", EUR: "€" };

export default {
  name: "Favorites",
  metaInfo() {
    return { title: "Платформа / " + this.t("title") };
  },
  data() {
    return {
      loading: true,
      items: [],
      busy: null,
      catalogUrl: process.env.VUE_APP_MAIN_PAGE + "/therapists",
    };
  },
  mounted() {
    AppServices.get("favorites")
      .then((response) => {
        this.items = response.data.data;
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    t(key) {
      return this.$vuetify.lang.t(`$vuetify.main.patientDashboard.favorites.${key}`);
    },
    prices(item) {
      return (item.service_prices || []).filter((price) => price && price.price).slice(0, 3);
    },
    formatPrice(price) {
      const amount = String(Math.round(Number(price.price))).replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      return `${amount} ${CURRENCY_SIGNS[price.currency] || "₴"}`;
    },
    remove(item) {
      this.busy = item.id;
      AppServices.delete("removeFavorite", { id: item.id })
        .then((response) => {
          this.items = this.items.filter((other) => other.id !== item.id);
          Vue.swal({
            target: document.getElementById("main"),
            text: response.data.message,
            icon: "success",
            timer: 2500,
            toast: true,
            position: "top-right",
            showConfirmButton: false,
          });
        })
        .finally(() => {
          this.busy = null;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.favorites {
  padding-top: 40px;
  padding-bottom: 60px;
}
.favorites__title {
  font-size: 28px;
  font-weight: 500;
  color: #575756;
  text-align: center;
}
.favorites__empty {
  max-width: 520px;
  margin: 40px auto 0;
  text-align: center;
  color: #575756;
}
.favorite-card {
  position: relative;
  height: 100%;
  padding: 28px 20px 24px;
  background: #fff;
  border: 1px solid #d9e4eb;
  border-radius: 12px;
  transition: box-shadow 0.2s;
}
.favorite-card:hover {
  box-shadow: 0 6px 24px rgba(0, 163, 183, 0.18);
}
.favorite-card__chat {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin-top: 10px;
  padding: 9px;
  border: 1px solid #00A3B7;
  border-radius: 8px;
  color: #00A3B7;
  text-decoration: none;
  &:hover {
    background: #F2FAFB;
  }
}
.favorite-card__remove {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 1;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #fff;
}
.favorite-card__link {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  color: #575756;
  text-decoration: none;
}
.favorite-card__name {
  margin-top: 16px;
  font-size: 20px;
}
.favorite-card__specialty {
  margin-top: 4px;
  color: #868686;
}
.favorite-card__methods {
  margin-top: 12px;
  font-size: 15px;
}
.favorite-card__price {
  margin-top: 6px;
  font-size: 15px;
  color: #00a3b7;
}
.favorite-card__more {
  margin-top: 20px;
  padding: 10px 24px;
  color: #fff;
  background: #00a3b7;
  border-radius: 8px;
}
</style>
